import { Bike, Car } from "lucide-react";

function MotoIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <circle cx="5.5" cy="17" r="3" />
      <circle cx="18.5" cy="17" r="3" />
      <path d="M5.5 17 9 11h6l3.5 6" />
      <path d="M15 11l-2-5h3" />
      <path d="M8 8h3" />
    </svg>
  );
}

export function VehicleIcon({ id, className }) {
  if (id === "carro") return <Car className={className} />;
  if (id === "bike") return <Bike className={className} />;
  return <MotoIcon className={className} />;
}
